import React from 'react';
import styled from 'styled-components';
import OrderDetails, { IOrderDetailItemValue } from './components/OrderDetail';
import PaymentMethods from './components/PaymentMethod';
import { ICustomerPaymentDetail } from '../Cashier/socket.interface';
import { IMultiCardResDataItem } from '../Cashier/payments/MultiCards/MultipleCardPayment/index.interface';

const Container = styled.div`
  padding: 0px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  zoom: 1.5;
`;

const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex: 1;
`;

interface Props {
  date: string;
  customerName: string;
  customerPhone: string;
  items: Array<IOrderDetailItemValue>;
  subtotal: number;
  cardFee?: number;
  saleTax?: number;
  useTax?: number;
  discount?: number;
  payments: ICustomerPaymentDetail;
  loyaltyAvailable?: number;
  total: number;
  ticketNumber?: number;
  onCancel?: () => void;
  onConfirm?: () => void;
  cards?: IMultiCardResDataItem[];
  multiCards?: boolean;
}

const CardPaymentDetail: React.FC<Props> = ({
  date,
  customerName,
  customerPhone,
  items,
  subtotal,
  cardFee = 0,
  saleTax = 0,
  useTax = 0,
  discount = 0,
  payments,
  loyaltyAvailable,
  total,
  ticketNumber = 0,
  onCancel,
  onConfirm,
  cards,
  multiCards,
}) => {
  return (
    <Container>
      <TwoColumn>
        <OrderDetails
          date={date}
          customerName={customerName}
          customerPhone={customerPhone}
          items={items}
          subtotal={subtotal}
          cardFee={cardFee}
          saleTax={saleTax}
          useTax={useTax}
          discount={discount}
          ticketNumber={ticketNumber}
        />
        <PaymentMethods
          payments={payments}
          loyaltyAvailable={loyaltyAvailable}
          total={total}
          onCancel={onCancel}
          onConfirm={onConfirm}
          cards={cards}
          multiCards={multiCards}
        />
      </TwoColumn>
    </Container>
  );
};

export default CardPaymentDetail;
